import parallax from "./parallax";
import swiper from "./swiper";
import intersectionObserverab from "./intersectionObserver";

window.addEventListener("DOMContentLoaded", () => {
  const Parallax = new parallax();
  const Swiper = new swiper();
  const IntersectionObserverab = new intersectionObserverab();
});
